
import Vue from "vue";
import ErrorPopupComponent from "./ErrorPopup.vue";

const ErrorPopupConstructor = Vue.extend(ErrorPopupComponent);

let seed = 1;

let instances = [];

class ErrorPopup {
	
	constructor() {
		window.onresize = ErrorPopup.closeAll;
	}
	
	install(Vue, options) {
		
		Vue.prototype.$errors = {
			
			show(anchor, options) {
				
				// If there's more than one error message
				// on the screen close the others before
				// showing the new one.
				
				if (instances.length) {
					ErrorPopup.closeAll();
				}
				
				const errorPopup = new ErrorPopupConstructor({
					propsData: {
						anchorRect: anchor.getBoundingClientRect(),
						...options
					}
				});
				
				errorPopup.id = `errorPopup${seed++}`
				errorPopup.$mount();
				
				document.body.appendChild(errorPopup.$el);
				
				errorPopup.visible = true;
				
				instances.push(errorPopup);
				
			},
			
			closeAll() {
				ErrorPopup.closeAll();
			}
			
		};
		
		Vue.prototype.$showError = function(ref, message) {
			
			// If there's more than one error message
			// on the screen close the others before
			// showing the new one.
			
			if (instances.length) {
				ErrorPopup.closeAll();
			}
			
			const errorPopup = new ErrorPopupConstructor({
				propsData: {
					coordinates: ref.$el.getBoundingClientRect(),
					message,
				}
			});
			
			errorPopup.id = `errorPopup${seed++}`
			
			errorPopup.$mount();
			
			document.body.appendChild(errorPopup.$el);
			
			errorPopup.visible = true;
			
			instances.push(errorPopup);
			
		}
		
	}
	
	static closeAll() {
		instances.map((instance) => {
			instance.close();
		});
	}
	
}

export default new ErrorPopup();
